import React from "react";
import { useAppSelector } from "../../../redux/hook";
import { Typography } from "@mui/material";
import { UNIT } from "../../../constants";
export default function CGU() {
  const { cgu } = useAppSelector((state) => state.configurationReducer);
  return (
    <Typography
      variant="body2"
      style={{ fontSize: UNIT * 0.6875 }}
      sx={{ color: "#515151" }}
    >
      En appuyant sur créer mon compte, vous acceptez nos{" "}
      <a href={cgu} target="_blank" rel="noopener noreferrer">
        Conditions générales{" "}
      </a>
      et notre{" "}
      <a href={cgu} target="_blank" rel="noopener noreferrer">
        Politique de confidentialité
      </a>
    </Typography>
  );
}
